import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import './AddModal.css';

function EditGroupModal({ group, profiles, proxies, closeModal, onDataEdited }) {
  const [nomeGrupo, setNomeGrupo] = useState('');
  const [selectedProfileId, setSelectedProfileId] = useState('');
  const [selectedProxyId, setSelectedProxyId] = useState('');
  const [defaultUrl, setDefaultUrl] = useState(''); // NOVO
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (group) {
      setNomeGrupo(group.nome_grupo);
      setSelectedProfileId(group.profile_id);
      setSelectedProxyId(group.proxies_id || '');
      setDefaultUrl(group.default_url || ''); // NOVO
    }
  }, [group]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error: updateError } = await supabase
      .from('grupos')
      .update({
        nome_grupo: nomeGrupo,
        profile_id: selectedProfileId,
        proxies_id: selectedProxyId || null,
        default_url: defaultUrl // NOVO
      })
      .eq('id', group.id);

    if (updateError) {
      setError(updateError.message);
    } else {
      onDataEdited();
      closeModal();
    }
    setLoading(false);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Editar Grupo</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome do Grupo</label>
            <input type="text" value={nomeGrupo} onChange={e => setNomeGrupo(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Associar ao Perfil</label>
            <select value={selectedProfileId} onChange={e => setSelectedProfileId(e.target.value)} required>
              <option value="" disabled>Selecione um perfil</option>
              {profiles.map(p => (<option key={p.id} value={p.id}>{p["profile name"]}</option>))}
            </select>
          </div>
          <div className="form-group">
            <label>Associar Proxy</label>
            <select value={selectedProxyId} onChange={e => setSelectedProxyId(e.target.value)}>
              <option value="">Nenhum</option>
              {proxies.map(proxy => (
                <option key={proxy.id} value={proxy.id}>
                  {proxy.host}:{proxy.port}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>URL Padrão</label>
            <input
              type="text"
              value={defaultUrl}
              onChange={e => setDefaultUrl(e.target.value)}
              required
              placeholder="https://exemplo.com"
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={closeModal} className="button-cancel">Cancelar</button>
            <button type="submit" className="button-save" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditGroupModal;